module.exports = __webpack_public_path__ + "img/android1.508b095c.jpeg";